import { Link } from "lucide-react";
import React from "react";

export const HeaderTread = () => {
  const logos = [
    { src: "https://hitch.cl/wms-lite", alt: "WMS Lite" },
    { src: "https://hitch.cl/facturacion-electronica", alt: "Add-on Facturación electrónica" },
    { src: "https://hitch.cl/middleware", alt: "Middleware" },
    { src: "https://hitch.cl/venta-en-ruta", alt: "Venta en Ruta" },
    { src: "https://hitch.cl/portal-cliente-proveedores", alt: "Portal de Clientes y Proveedores" },
    { src: "https://insideone.io/", alt: "InsideOne" },
  ];
  return (
    <div className="relative overflow-hidden border-b bg-hitch/40">
      <style>{`
        @keyframes treadMoveHeader { 0% { background-position: 0px 0, 0 0; } 100% { background-position: -800px 0, 800px 0; } }
        @keyframes marqueeHeader { 0% { transform: translateX(-50%); } 100% { transform: translateX(0); } }
      `}</style>
      {/* Capa de huellas / asfalto */}
      <div
        className="absolute inset-0 opacity-[0.16]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(115deg, rgba(255,255,255,.09) 0 10px, transparent 10px 22px), repeating-linear-gradient(65deg, rgba(255,255,255,.08) 0 10px, transparent 10px 22px)",
          backgroundSize: "260px 260px, 260px 260px",
          animation: "treadMoveHeader 18s linear infinite",
        }}
      />
      {/* Glow rojo inferior tipo pit lane */}
      <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-red-500 via-red-400 bg-hitch" />
      <div className="absolute bottom-0 left-0 right-0 h-8 bg-hitch/10 blur-xl" />

      {/* Marquee fino */}
      <div className="max-w-6xl mx-auto px-6 py-2">
        <div className="overflow-hidden">
          <div className="flex gap-10 whitespace-nowrap will-change-transform" style={{ animation: "marqueeHeader 20s linear infinite" }}>
            {[...Array(2)].map((_, pass) => (
              <div key={pass} className="flex gap-10 items-center">
                {/* Ruedita + HITCH centrado */}
                {logos.map((l, i) => (
                  <div key={`${pass}-${i}`} className="flex items-center gap-3 opacity-90">
                    <div className="w-5 h-5 rounded-full bg-gradient-to-b from-gray-300 to-gray-600 shadow-inner relative">
                      <span className="absolute inset-0 rounded-full" style={{ boxShadow: "inset 0 0 0 2px #2b2b2b, inset 0 0 0 6px #1a1a1a" }} />
                      <span className="absolute left-1 right-1 top-1/2 -translate-y-1/2 h-[2px] bg-red-500/90 rounded" />
                    </div>
                    <a href={l.src} target="_blank">
                      <p>{l.alt}</p>
                    </a>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
